import { Component, OnInit } from '@angular/core';
import { HttpStatusService } from '@app/core/http-status.service';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent implements OnInit {
  title = 'Страница не найдена';

  constructor(private httpStatusService: HttpStatusService) { }

  ngOnInit() {
    this.httpStatusService.setHttpStatus(404);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/not-found-page/not-found-page.component.ts